module.exports = __webpack_public_path__ + "static/img/JM.4622fe12.svg";